import React from 'react';
import {
  AccountsOverview,
  DataSources,
  OtherData,
  OutcomeReasons,
  RecentTransactions,
  Tags,
  WatchlistMatches,
} from '../cards';
import { Col, Row } from '../common';
import { useEventTypeEvaluationsContext } from '../context';
import { hasDataSourcesData, hasFraudSignalServiceConfigured } from '../../utils/cardDataChecks';
import { shouldRenderCard } from '../../utils/shouldRenderCard';
import { FraudSignalCard } from '../../FraudSignalCard';
import { useFetchedUserContext } from '~/helpers/hooks';

export const TransactionCards = () => {
  const { evaluation } = useEventTypeEvaluationsContext();
  const { feature_flags: featureFlags } = useFetchedUserContext();
  const hideEmptyCardsEnabled = !!featureFlags?.['remove-empty-cards'];

  return (
    <>
      <Row>
        <Col>
          <AccountsOverview />
        </Col>
        <Col>
          <OutcomeReasons />
          <Tags />
          <FraudSignalCard
            evaluationToken={evaluation.evaluation_token}
            hasFraudSignalService={hasFraudSignalServiceConfigured(evaluation)}
          />
          {shouldRenderCard(hasDataSourcesData(evaluation), hideEmptyCardsEnabled)
            && <DataSources />}
          <OtherData />
        </Col>
      </Row>
      <RecentTransactions />
      <WatchlistMatches />
    </>
  );
};
